import { render, staticRenderFns } from "./version-validator.vue?vue&type=template&id=2b399200&"
import script from "./version-validator.vue?vue&type=script&lang=ts&"
export * from "./version-validator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports